import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import EnterpriseLayout from "./EnterpriseLayout";
import { ClientLoginForm } from "./components/ClientLoginForm";
import { ENTERPRISE_LINKS } from "./enterpriseLinks";

export default function EnterpriseLogin() {
  return (
    <EnterpriseLayout
      title="Client Login — Rentid Enterprise"
      description="Sign in to your Rentid Enterprise client account."
      path={ENTERPRISE_LINKS.login}
    >
      <div className="mx-auto flex max-w-md flex-col gap-8 px-4 pt-20 pb-24 sm:px-6 lg:pt-16">
        <Link
          to={ENTERPRISE_LINKS.home}
          className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back to Rentid Enterprise
        </Link>
        <div className="flex flex-col gap-3">
          <h1 className="font-heading text-4xl font-semibold leading-[1.02] tracking-tighter text-foreground text-balance">
            Client Login
          </h1>
          <p className="text-lg leading-relaxed text-muted-foreground">Sign in to your Rentid Enterprise account.</p>
        </div>
        <div className="rounded-3xl border border-border bg-card p-6 shadow-sm sm:p-8">
          <ClientLoginForm />
        </div>
      </div>
    </EnterpriseLayout>
  );
}
